import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import type {RootState} from '../index'

export type country = {
  id: number
  code: string
  name?: string
  active?: boolean
  timeZones?: {
    code: string
    name: string
  }
}

interface CommonState {
  country: country
  application: string
  shellActive: boolean
  shellPath: string
  market: string
}

const initialState: CommonState = {
  country: {id: 0, code: '', name: ''},
  application: 'B2B',
  shellActive: false,
  shellPath: '',
  market: '',
}
const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCountry: (state, action: PayloadAction<country>) => {
      return {
        ...state,
        country: action.payload,
      }
    },
    setShellActive: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        shellActive: action.payload,
      }
    },
    setShellPath: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        shellPath: action.payload,
      }
    },
    setMarket: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        market: action.payload,
      }
    },
    setApplication: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        application: action.payload,
      }
    },
  },
})

export const {setShellActive, setShellPath, setMarket, setApplication, setCountry} = common.actions

export const selectShellActive = (state: RootState) => state.common.shellActive
export const selectShellPath = (state: RootState) => state.common.shellPath
export const selectMarket = (state: RootState) => state.common.market
export const selectApplication = (state: RootState) => state.common.application
export const commonSliceReducer = common.reducer
